// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from cc-zero-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function CcZeroFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.983 0c2.238 0 4.148.78 5.72 2.342a7.662 7.662 0 0 1 1.715 2.582c.39.962.582 1.99.582 3.076a8.13 8.13 0 0 1-.583 3.087 7.262 7.262 0 0 1-1.703 2.526 8.213 8.213 0 0 1-2.655 1.77c-.99.41-2.018.617-3.076.617a7.902 7.902 0 0 1-3.042-.6 8.301 8.301 0 0 1-2.6-1.759A8.087 8.087 0 0 1 .6 11.042 7.84 7.84 0 0 1 0 8c0-1.057.2-2.07.6-3.042a8.12 8.12 0 0 1 1.77-2.633C3.893.772 5.764 0 7.983 0ZM8 3.395c-2.419 0-3.18 2.09-3.29 4.065l-.01.185L4.695 8l.007.355.02.36c.145 1.921.931 3.89 3.279 3.89 2.641 0 3.305-2.492 3.305-4.605 0-2.113-.664-4.605-3.305-4.605Zm1.316 3.227.04.249c.024.166.039.331.049.49l.011.23.007.516-.008.363-.015.267-.026.279-.04.283c-.136.801-.478 1.57-1.333 1.57a1.31 1.31 0 0 1-.204-.015l-.093-.02-.135-.043c-.28-.12-.463-.327-.274-.682l.056-.092 1.965-3.395ZM8 5.132c.107 0 .205.016.297.039.17.146.261.34.152.604l-.051.101-1.76 3.233-.026-.244a8.691 8.691 0 0 1-.034-.674v-.413l.007-.249.015-.266.026-.279.04-.283c.136-.801.479-1.57 1.334-1.57Z"
      />
    </svg>
  );
}
